import { StringContextType } from "@faire/web-api/faire/translator/StringContextType";
import brandPortalOrdersbrandOrderTokenOrderFulfilment from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/order-fulfilment";
import React from "react";
import { ViewPayoutsCTA } from "./ctas";
import { DiscrepancyInPayoutTotalIA } from "./instantAnswersComponents/payments/DiscrepancyInPayoutTotalIA";
export var discrepancyInPayoutTotal = function discrepancyInPayoutTotal(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DISCREPANCY_IN_PAYOUT_TOTAL_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return DISCREPANCY_IN_PAYOUT_TOTAL_DESCRIPTION(context);
    }
  };
};
var DISCREPANCY_IN_PAYOUT_TOTAL_TITLE = function DISCREPANCY_IN_PAYOUT_TOTAL_TITLE(strictLocalize) {
  return strictLocalize({
    id: "BaL7qS",
    defaultMessage: [{
      "type": 0,
      "value": "Controleer je uitbetaling op afwijkingen"
    }]
  });
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  var _brandOrder$brand_ord;
  var brandOrder = context.brandOrder;
  if (brandOrder && (_brandOrder$brand_ord = brandOrder.brand_order) !== null && _brandOrder$brand_ord !== void 0 && _brandOrder$brand_ord.token) {
    return {
      label: strictLocalize({
        id: "d/5WQ/",
        defaultMessage: "View order details"
      }),
      getLink: function getLink() {
        var _brandOrder$brand_ord2, _brandOrder$brand_ord3;
        return brandPortalOrdersbrandOrderTokenOrderFulfilment((_brandOrder$brand_ord2 = (_brandOrder$brand_ord3 = brandOrder.brand_order) === null || _brandOrder$brand_ord3 === void 0 ? void 0 : _brandOrder$brand_ord3.token) !== null && _brandOrder$brand_ord2 !== void 0 ? _brandOrder$brand_ord2 : "", {
          sync: "true"
        });
      }
    };
  }
  return ViewPayoutsCTA(strictLocalize);
};
var DISCREPANCY_IN_PAYOUT_TOTAL_DESCRIPTION = function DISCREPANCY_IN_PAYOUT_TOTAL_DESCRIPTION(context) {
  var brandOrder = context.brandOrder;
  return /*#__PURE__*/React.createElement(DiscrepancyInPayoutTotalIA, {
    brandOrder: brandOrder
  });
};